/**
 * Promote LimeSpot recommendation box titles from h3 to h2.
 * LimeSpot injects <h3 class="ls-box-title">; the theme cannot change that
 * tag in Liquid. Do not add this to snippets/limespot.liquid — the app
 * overwrites that snippet (checksum).
 */
(() => {
  const TITLE_SELECTOR = 'h3.ls-box-title';

  const promoteTitle = (heading) => {
    if (!(heading instanceof HTMLElement) || heading.tagName !== 'H3') return;

    const replacement = document.createElement('h2');

    for (const attribute of heading.attributes) {
      replacement.setAttribute(attribute.name, attribute.value);
    }

    replacement.replaceChildren(...heading.childNodes);
    heading.replaceWith(replacement);
  };

  const promoteTitles = (root = document) => {
    const isElement = root instanceof Element;
    if (!isElement && root !== document) return;

    const matches =
      isElement && root.matches(TITLE_SELECTOR)
        ? [root]
        : [...root.querySelectorAll(TITLE_SELECTOR)];

    for (const heading of matches) {
      promoteTitle(heading);
    }
  };

  document.addEventListener('limespot:recommendationBoxLoaded', (event) => {
    promoteTitles(event.detail?.box ?? document);
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        promoteTitles(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => promoteTitles(), { once: true });
    return;
  }

  promoteTitles();
})();
